module.exports = __webpack_public_path__ + "img/Image_OldComp.17525bc3.svg";